import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import QualityIndicators from '../helpers/quality-indicators';
import SystemTypes from '../helpers/system-types';
import TraceRouteParser from '../helpers/traceroute-parser';
    

    var BRIDGE_TYPE_ID = SystemTypes.getBridgeTypeIdentifier();
    var REALTIME_BRIDGE_TYPE_LIST = SystemTypes.getRealtimeBridgeTypes();
    var CALL_CONTROL_TYPE_ID = SystemTypes.getCallControlTypeIdentifier();
    var CALL_CONTROL_TYPE_LIST = SystemTypes.getRealtimeCallControlTypes();

    function addIfNotEmpty(obj, propName, value) {
        if (!_.isEmpty(value)) {
            obj[propName] = value;
        }
    }

    function convertToKbps(valueStr) {
        var val = parseInt(valueStr, 10);
        return (val >= 0) ? Math.round(val / 1000).toString() : '';
    }

    function createSystemTrendDictionary(self) {
        var systemTrendDictionary = {};
        self.systemTrendDataInitial().forEach(function (trendItem) {
            if (!systemTrendDictionary[trendItem.sysName]) {
                systemTrendDictionary[trendItem.sysName] = [];
            }
            systemTrendDictionary[trendItem.sysName].push(trendItem);
        });
        self.systemTrendDictionary(systemTrendDictionary);
    }

    function emptyQuality(source) {
        // check if the source is empty or fill with empty strings
        return _.isEmpty(_.filter(source, function (item) {
            return !_.isEmpty(item);
        }));
    }

    function extractCallControlData(self, details) {
        var callControlList = [];
        var overallQualityTotals = self.overallQualityTotals();
        var systemDetailParticipantData = self.systemDetailParticipantData();
        var currentIds = systemDetailParticipantData ? Object.keys(systemDetailParticipantData) : [];

        _.set(overallQualityTotals, 'callparticipants', []);

        _.chain(_.get(details, 'SystemDetail'))
            .flatMap(function (detail) {
                var systemDetailsOfInterestObj = {
                    systemDetailsOfInterest: {
                        recordType: detail.recordType,
                        systemCallsNow: _.get(detail, 'Item.length'),
                        systemhost: detail.host,
                        systemid: detail.id,
                        systemLicenseUsage: detail.LicenseUsage,
                        systemname: detail.name,
                        systemstatus: detail.status,
                        systemtype: detail.type
                    }
                };

                return _.map(_.get(detail, 'Item'), function (item) {
                    return _.extend({}, systemDetailsOfInterestObj, item);
                });
            })
            .filter(function (item) {
                return !_.isNil(item) && isCallControl(item, item.systemDetailsOfInterest.systemtype);
            })
            .forEach(function (item) {
                var systemDetailsOfInterestObj = _.get(item, 'systemDetailsOfInterest');
                var qualityObj = getQualityObject(item);

                if (!systemDetailParticipantData[qualityObj.id]) {
                    systemDetailParticipantData[qualityObj.id] = [];
                }

                // NOTE: this is linked to 8 data points on quality page
                pushToMax(systemDetailParticipantData[qualityObj.id], qualityObj, 9);
                _.pull(currentIds, qualityObj.id);

                var dt = new Date(getRTDataElement(item.StartTime));

                var ccObj = _.extend({}, systemDetailsOfInterestObj, {
                    bitrate: qualityObj.bitrate,
                    destinationAlias: getRTDataElement(item.DestinationAlias),
                    duration: getDuration(dt),
                    hasQualityData: qualityObj.hasQualityData,
                    id: qualityObj.id,
                    mediaRouted: getRTDataElement(item.MediaRouted),
                    presentation: getRTDataElement(item.Presentation) || '',
                    qobj: qualityObj,
                    qualityIndicator: qualityObj.hasQualityData ? qualityObj.qualityIndicator : -1,
                    sourceAlias:
                        getRTDataElement(item.SourceAlias),
                    startTime: dt,
                    type: _.get(item, 'type')
                });
                callControlList.push(ccObj);

                if (!overallQualityTotals.callparticipants[qualityObj.qualityIndicator]) {
                    overallQualityTotals.callparticipants[qualityObj.qualityIndicator] = 0;
                }

                if (!overallQualityTotals.callparticipants.total) {
                    overallQualityTotals.callparticipants.total = 0;
                }

                overallQualityTotals.callparticipants[qualityObj.qualityIndicator]++;
                overallQualityTotals.callparticipants.total++;
            })
            .value();

        self.systemDetailDataCallControls(callControlList);
        self.overallQualityTotals(overallQualityTotals);

        currentIds.forEach(function (id) {
            delete systemDetailParticipantData[id];
        });
        self.systemDetailParticipantData(systemDetailParticipantData);
    }

    function extractCallData(self, statusData) {
        var endpointCallData = self.endpointCallData();
        var currentIds = endpointCallData ? Object.keys(endpointCallData) : [];
        var overallQualityTotals = self.overallQualityTotals();

        _.set(overallQualityTotals, 'endpoints', []);

        _.chain(statusData)
            .filter(function (item) {
                return (item.status === 'InCall');
            })
            .forEach(function (item) {
                item.qualityIndicator =
                    _.isEmpty(item.RtData) ? 0 : fillCallQualityDetails(self, item.RtData[0], item, currentIds);

                if (!overallQualityTotals.endpoints[item.qualityIndicator]) {
                    overallQualityTotals.endpoints[item.qualityIndicator] = 0;
                }

                if (!overallQualityTotals.endpoints.total) {
                    overallQualityTotals.endpoints.total = 0;
                }

                overallQualityTotals.endpoints[item.qualityIndicator] = overallQualityTotals.endpoints[item.qualityIndicator] + 1;
                overallQualityTotals.endpoints.total = overallQualityTotals.endpoints.total + 1;
            })
            .value();

        currentIds.forEach(function (id) {
            endpointCallData[id].push(null);
        });
        self.endpointCallData(endpointCallData);
        self.overallQualityTotals(overallQualityTotals);
    }

    function extractSystemStatuses(self, systemStatusData) {
        var systemStatusDataAcano = [];
        var systemStatusDataAllBridges = [];
        var systemStatusDataBlueJeans = [];
        var systemStatusDataCTPSCondMgd = [];
        var systemStatusDataCTPSStandalone = [];
        var systemStatusDataCUCM = [];
        var systemStatusDataDMA = [];
        var systemStatusDataMCU = [];
        var systemStatusDataPexip = [];
        var systemStatusDataPexipLocations = self.systemStatusDataPexipLocations();
        var systemStatusDataRMX = [];
        var systemStatusDataSKYPE = [];
        var systemStatusDataCallControls = [];
        var systemStatusDataVCSOnly = [];
        var systemStatusDataVCSX = [];
        var systemStatusDataZOOM = [];
        var systemStatusDataRPAD = [];
        var systemStatusDataRPRM = [];

        if (!_.isEmpty(systemStatusData)) {
            systemStatusData.forEach(function (item) {
                var type = _.toUpper(item.type);
                switch (type) {
                    case 'ACANO':
                    case 'CMS':
                        systemStatusDataAcano.push(item);
                        break;

                    case 'BJN':
                        systemStatusDataBlueJeans.push(item);
                        break;

                    case 'CTPS':
                        if ((!item.OperationMode) || (item.OperationMode.toUpperCase() === 'STANDALONE')) {
                            systemStatusDataCTPSStandalone.push(item);

                        } else if (item.OperationMode.toUpperCase() === 'FLEXIBLE') {
                            systemStatusDataCTPSCondMgd.push(item);
                        }
                        break;

                    case 'CUCM':
                        systemStatusDataCUCM.push(item);
                        break;

                    case 'DMA':
                        systemStatusDataDMA.push(item);
                        break;

                    case 'PEXIP':
                        systemStatusDataPexip.push(item);

                        if (!systemStatusDataPexipLocations[item.id]) {
                            systemStatusDataPexipLocations[item.id] = [];
                        }

                        if (item.SystemLocations) {
                            var sysloc;
                            try {
                                sysloc = JSON.parse(item.SystemLocations);
                            } catch (e) {
                                sysloc = {};
                                console.error('Unable to parse "SystemLocations"', e);
                            }
                            systemStatusDataPexipLocations[item.id].push(sysloc);
                        }
                        break;

                    case 'RMX':
                        systemStatusDataRMX.push(item);
                        break;

                    case 'RPAD':
                        systemStatusDataRPAD.push(item);
                        break;

                    case 'RPRM':
                        systemStatusDataRPRM.push(item);
                        break;

                    case 'SKYPE':
                        systemStatusDataSKYPE.push(item);
                        break;

                    case 'VCS':
                        systemStatusDataVCSOnly.push(item);
                        break;

                    case 'VCSX':
                        systemStatusDataVCSX.push(item);
                        break;

                    case 'ZOOM':
                        systemStatusDataZOOM.push(item);
                        break;

                    default:
                        if ((!item.OperationMode) || (item.OperationMode.toUpperCase() === 'STANDALONE')) {
                            systemStatusDataMCU.push(item);
                        }
                        break;
                }
                if (SystemTypes.isCallControl(type)) {
                    systemStatusDataCallControls.push(item);
                }
                else if (SystemTypes.isBridge(type)) {
                    systemStatusDataAllBridges.push(item);
                }
            });
        }

        self.systemStatusDataAcano(systemStatusDataAcano);
        self.systemStatusDataAllBridges(systemStatusDataAllBridges);
        self.systemStatusDataBlueJeans(systemStatusDataBlueJeans);
        self.systemStatusDataCTPSCondMgd(systemStatusDataCTPSCondMgd);
        self.systemStatusDataCTPSStandalone(systemStatusDataCTPSStandalone);
        self.systemStatusDataCUCM(systemStatusDataCUCM);
        self.systemStatusDataDMA(systemStatusDataDMA);
        self.systemStatusDataMCU(systemStatusDataMCU);
        self.systemStatusDataPexip(systemStatusDataPexip);
        self.systemStatusDataPexipLocations(systemStatusDataPexipLocations);
        self.systemStatusDataRMX(systemStatusDataRMX);
        self.systemStatusDataSKYPE(systemStatusDataSKYPE);
        self.systemStatusDataCallControls(systemStatusDataCallControls);
        self.systemStatusDataVCSOnly(systemStatusDataVCSOnly);
        self.systemStatusDataVCSX(systemStatusDataVCSX);
        self.systemStatusDataZOOM(systemStatusDataZOOM);
        self.systemStatusDataRPAD(systemStatusDataRPAD);
        self.systemStatusDataRPRM(systemStatusDataRPRM);

        self.dictionaryOfNonBridgesNonCallControlsWithIdsObservable(self.getDictionaryOfNonBridgesNonCallControlsWithIds());
        self.dictionaryOfBridgesWithIdsObservable(self.getDictionaryOfBridgesWithIds());
        self.dictionaryOfCallControlsWithIdsObservable(self.getDictionaryOfCallControlsWithIds());
        self.dictionaryOfSystemsObservable(self.getDictionaryOfSystems());
        self.listOfPexipLocationsObservable(self.getListOfPexipLocations());

        // Some bindings listen to this to tell when they can inspect specific status observables (e.g. systemStatusDataPexip),
        // so this needs to be set after all others.
        self.systemStatusData(systemStatusData);
    }

    function extractVMRData(self, details) {
        var vmrList = [];
        var overallQualityTotals = self.overallQualityTotals();
        var systemDetailParticipantData = self.systemDetailParticipantData();
        var currentIds = systemDetailParticipantData ? Object.keys(systemDetailParticipantData) : [];

        _.set(overallQualityTotals, 'vmrs', []);

        _.chain(_.get(details, 'SystemDetail'))
            .flatMap(function (detail) {
                var systemDetailsOfInterestObj = {
                    systemDetailsOfInterest: {
                        recordType: detail.recordType,
                        systemCallsNow: _.get(detail, 'Item.length'),
                        systemhost: detail.host,
                        systemid: detail.id,
                        systemLicenseUsage: detail.LicenseUsage,
                        systemname: detail.name,
                        systemstatus: detail.status,
                        systemtype: detail.type
                    }
                };

                return _.map(_.get(detail, 'Item'), function (item) {
                    return _.extend({}, systemDetailsOfInterestObj, item);
                });
            })
            .filter(function (item) {
                return !_.isNil(item) && isBridge(item, item.systemDetailsOfInterest.systemtype);
            })
            .forEach(function (item) {
                var hasQualityData = false;
                var maxInd = 0;
                var participants = [];
                var systemDetailsOfInterestObj = _.get(item, 'systemDetailsOfInterest');

                _.forEach(item.Participants, function (participant) {
                    var qualityObj = getQualityObject(participant);

                    if (qualityObj.hasQualityData) {
                        hasQualityData = true;

                        switchTransmitAndReceive(qualityObj);

                        if (qualityObj.qualityIndicator > maxInd) {
                            maxInd = qualityObj.qualityIndicator;
                        }

                        if (!systemDetailParticipantData[qualityObj.id]) {
                            systemDetailParticipantData[qualityObj.id] = [];
                        }

                        // NOTE: this is linked to 8 data points on quality page
                        pushToMax(systemDetailParticipantData[qualityObj.id], qualityObj, 9);
                        _.pull(currentIds, qualityObj.id);
                    }
                    participants.push(qualityObj);
                });

                var dt = new Date(getRTDataElement(item.StartTime));
                var presenting = getRTDataElement(item.Presenting);

                var vmrObj = _.extend({}, systemDetailsOfInterestObj, {
                    duration: getDuration(dt),
                    hasQualityData: hasQualityData,
                    id: getRTDataElement(item.id),
                    name: getRTDataElement(item.name),
                    numOfParticipants: getRTDataElement(item.NumOfParticipants),
                    participants: participants,
                    presentation: presenting,
                    qualityIndicator: maxInd,
                    startTime: dt,
                    type: _.get(item, 'type')
                });
                vmrList.push(vmrObj);

                if (!overallQualityTotals.vmrs[maxInd]) {
                    overallQualityTotals.vmrs[maxInd] = 0;
                }

                if (!overallQualityTotals.vmrs.total) {
                    overallQualityTotals.vmrs.total = 0;
                }

                overallQualityTotals.vmrs[maxInd]++;
                overallQualityTotals.vmrs.total++;
            })
            .value();

        self.systemDetailDataAllBridges(vmrList);
        self.overallQualityTotals(overallQualityTotals);

        currentIds.forEach(function (id) {
            delete systemDetailParticipantData[id];
        });
        self.systemDetailParticipantData(systemDetailParticipantData);
    }

    function fillCallQualityDetails(self, rtdata, system, currentids) {
        var endpointCallData = self.endpointCallData();
        var maxind = 0;

        _.forEach(_.get(rtdata, 'calls'), function (call) {
            var obj = getQualityObject(call, true, system);
            switchTransmitAndReceive(obj);
            obj.endpointsystemdetail = system;

            if (!_.isEmpty(obj)) {
                if (obj.qualityIndicator > maxind) {
                    maxind = obj.qualityIndicator;
                }

                if (!endpointCallData[obj.id]) {
                    endpointCallData[obj.id] = [];
                }

                // NOTE: this is linked to 8 data points on call quality page
                pushToMax(endpointCallData[obj.id], obj, 9);
                _.pull(currentids, obj.id);
            }
        });

        self.endpointCallData(endpointCallData);
        return maxind;
    }

    function getCodec(item) {
        var rawCodec = _.get(item, 'Codec', '');
        if (_.isEmpty(rawCodec)) {
            return '';
        }

        var rtDataElement = getRTDataElement(rawCodec);
        if (isOff(rtDataElement)) {
            return '';
        }

        return rtDataElement;
    }

    function getDuration(starttime) {
        return starttime ? (new Date() - starttime) : 0;
    }

    function getMaxValue(source) {
        return _.max(source) || 0;
    }

    function getQualityObject(call, isEndPoint, system) {
        var obj = {};

        // adjust for demo data from sp
        if (!call.id && call.call_id) {
            call.id = call.call_id;
        }

        var callId = _.get(call, 'id[0].text');

        if (callId) {
            obj.id = callId;
            obj.calltype = getRTDataElement(call.CallType);

            obj.callisvideooraudio = (!obj.calltype) || (obj.calltype.toUpperCase() === 'AUDIO') ||
                (obj.calltype.toUpperCase() === 'VIDEO');

            obj.presentation = getRTDataElement(call.Presentation);
            obj.protocol = getRTDataElement(call.Protocol);
            obj.name = getRTDataElement(call.name);
            obj.remoteaddr = getRTDataElement(call.RemoteAddress);
            obj.bitrate = getRTDataElement(call.BitRate ? call.BitRate : call.Bitrate);
            obj.bitrate = isEndPoint ? obj.bitrate : convertToKbps(obj.bitrate);
            obj.traceroute = TraceRouteParser.parse(call.Traceroute, system);
            var dt = new Date(getRTDataElement(call.StartTime));
            obj.starttime = dt;
            obj.duration = getDuration(dt);

            var txAudio = _.get(call, 'TxAudio[0]', {});
            var rxAudio = _.get(call, 'RxAudio[0]', {});
            var txVideo = _.get(call, 'TxVideo[0]', {});
            var rxVideo = _.get(call, 'RxVideo[0]', {});
            var txPres = _.get(call, 'TxPresentation[0]', {});
            var rxPres = _.get(call, 'RxPresentation[0]', {});

            var hasTxAudio = setChannelProperties(obj, 'txAudio', txAudio);
            var hasRxAudio = setChannelProperties(obj, 'rxAudio', rxAudio);
            var hasTxVideo = setChannelProperties(obj, 'txVideo', txVideo);
            var hasRxVideo = setChannelProperties(obj, 'rxVideo', rxVideo);

            setChannelProperties(obj, 'txPres', txPres);
            setChannelProperties(obj, 'rxPres', rxPres);

            obj.hasQualityData = hasRxAudio || hasTxAudio || hasTxVideo || hasRxVideo;

            if (obj.hasQualityData) {
                obj.jitterQualityIndicator = QualityIndicators.getJitterQuality(getWorstQualityValue([
                    obj.txAudioJitter,
                    obj.txVideoJitter,
                    obj.txPresJitter,
                    obj.rxAudioJitter,
                    obj.rxVideoJitter,
                    obj.rxPresJitter
                ]));

                obj.packetlossQualityIndicator = QualityIndicators.getPacketLossQuality(getWorstQualityValue([
                    obj.txAudioPacketlossPerc,
                    obj.txVideoPacketlossPerc,
                    obj.txPresPacketlossPerc,
                    obj.rxAudioPacketlossPerc,
                    obj.rxVideoPacketlossPerc,
                    obj.rxPresPacketlossPerc
                ]));

                obj.qualityIndicator = getMaxValue([
                    obj.jitterQualityIndicator,
                    obj.packetlossQualityIndicator
                ]);

                obj.maxPacketloss = getMaxValue([
                    obj.txAudioPacketlossPerc,
                    obj.txVideoPacketlossPerc,
                    obj.txPresPacketlossPerc,
                    obj.rxAudioPacketlossPerc,
                    obj.rxVideoPacketlossPerc,
                    obj.rxPresPacketlossPerc
                ]);

                obj.maxJitter = getMaxValue([
                    obj.txAudioJitter,
                    obj.txVideoJitter,
                    obj.txPresJitter,
                    obj.rxAudioJitter,
                    obj.rxVideoJitter,
                    obj.rxPresJitter
                ]);

            } else {
                obj.qualityIndicator = 0; // unknown
            }
        }

        return obj;
    }

    function getRTDataElement(source, numeric) {
        var result = null;
        var textValue = _.get(source, '[0].text', null);

        if (!numeric) {
            return textValue;
        }

        if (textValue && $.isNumeric(textValue)) {
            result = parseFloat(textValue).toFixed(0);

            if (result === -1) {
                result = null;
            }
        }

        return result;
    }

    function getSystemIdsAndNames(source) {
        var result = [];
        if (source) {
            source.forEach(function (item) {
                result.push({ id: item.id, name: item.name });
            });
        }
        return result;
    }

    function getSystemNames(source) {
        var result = [];
        if (source) {
            source.forEach(function (item) {
                result.push(item.name);
            });
        }
        return result;
    }

    function getWorstQualityValue(sourceArray) {
        return emptyQuality(sourceArray) ? -1 : _.max(sourceArray);
    }

    function isOnBridgeList(systemType) {
        return _.includes(REALTIME_BRIDGE_TYPE_LIST, systemType);
    }

    function isBridge(item, systemType) {
        return _.has(item, 'type') ? (_.toLower(item.type) === BRIDGE_TYPE_ID) : isOnBridgeList(systemType) /*backwards-compatibility*/;
    }

    function isOnCallControlList(systemType) {
        return _.includes(CALL_CONTROL_TYPE_LIST, systemType);
    }

    function isCallControl(item, systemType) {
        return _.has(item, 'type') ? (_.toLower(item.type) === CALL_CONTROL_TYPE_ID) : isOnCallControlList(systemType) /*backwards-compatibility*/;
    }

    function isOff(value) {
        value = _.toUpper(value);
        return (value === 'OFF' || value === 'UNKNOWN');
    }

    function pushToMax(array, newvalue, max) {
        if (array.length >= max) {
            array.shift();
        }
        array.push(newvalue);
    }

    function pushToMaxObservable(array, newvalue, max) {
        if (array().length >= max) {
            array.shift();
        }
        array.push(newvalue);
    }

    /**
     * Given channel data, it sets the destination object with the corresponding channel properties.
     * Ex. txAudioChannelRate, txAudioFramerate, txAudioJitter, etc.
     * @returns true if there if the codec value and the destination object are not empty, false otherwise.
     */
    function setChannelProperties(destObj, channelName, channelData) {
        if (_.isEmpty(destObj) || _.isEmpty(channelData)) {
            return false;
        }

        var codec = getCodec(channelData);
        destObj[channelName + 'Codec'] = codec;

        if (!_.isEmpty(codec) && _.toUpper(codec) === 'OFF') {
            destObj[channelName + 'Channelrate'] = '';
            destObj[channelName + 'Framerate'] = '';
            destObj[channelName + 'Jitter'] = '';
            destObj[channelName + 'Packetloss'] = '';
            destObj[channelName + 'PacketlossPerc'] = '';
            destObj[channelName + 'Resolution'] = '';
            return false; // no codec value
        }

        destObj[channelName + 'Channelrate'] = getRTDataElement(channelData.BitRate, true);
        destObj[channelName + 'Framerate'] = getRTDataElement(channelData.FrameRate, true);
        destObj[channelName + 'Jitter'] = getRTDataElement(channelData.Jitter, true);
        var packetLoss = getRTDataElement(channelData.PacketLossRate, false);
        destObj[channelName + 'Packetloss'] = packetLoss;
        destObj[channelName + 'PacketlossPerc'] = toPacketLossPercent(packetLoss);
        destObj[channelName + 'Resolution'] = getRTDataElement(channelData.Resolution);

        return true; // codec value is not empty
    }

    function setSystemDetailParticipantData(self, system) {
        var systemDetailParticipantData = self.systemDetailParticipantData();
        var currentIds = systemDetailParticipantData ? Object.keys(systemDetailParticipantData) : [];
        var items = _.get(system, 'Item');

        if (!_.isNil(items)) {
            _.forEach(items, function (item) {
                if (isBridge(item, system.type)) {
                    setParticipantDataForBridgeSystems(item);
                } else if (isCallControl(item, system.type)) {
                    setParticipantDataForCallControlSystems(item);

                }
            });
        }

        currentIds.forEach(function (id) {
            systemDetailParticipantData[id].push(null);
        });

        self.systemDetailParticipantData(systemDetailParticipantData);

        function setParticipantDataForBridgeSystems(vmr) {
            _.forEach(vmr.Participants, function (participant) {
                var qualityObj = getQualityObject(participant);
                switchTransmitAndReceive(qualityObj);
                qualityObj.vmrdetail = vmr;

                if (!systemDetailParticipantData[qualityObj.id]) {
                    systemDetailParticipantData[qualityObj.id] = [];
                }

                // NOTE: this is linked to 8 data points on quality page
                pushToMax(systemDetailParticipantData[qualityObj.id], qualityObj, 9);
                _.pull(currentIds, qualityObj.id);
            });
        }

        function setParticipantDataForCallControlSystems(callParticipant) {
            var qualityObj = getQualityObject(callParticipant);
            qualityObj.ccsystemdetail = system;
            qualityObj.sourceAlias = getRTDataElement(callParticipant.SourceAlias);
            qualityObj.destinationAlias = getRTDataElement(callParticipant.DestinationAlias);

            if (!systemDetailParticipantData[qualityObj.id]) {
                systemDetailParticipantData[qualityObj.id] = [];
            }

            // NOTE: this is linked to 8 datapoints on quality page
            pushToMax(systemDetailParticipantData[qualityObj.id], qualityObj, 9);
            _.pull(currentIds, qualityObj.id);
        }
    }

    function shiftSystemTrendDataValues(self) {
        var systemTrendDictionary = self.systemTrendDictionary();
        self.systemTrendDataIncremental().forEach(function (trendItem) {
            if (!systemTrendDictionary[trendItem.sysName]) {
                systemTrendDictionary[trendItem.sysName] = [];
            }
            if (systemTrendDictionary[trendItem.sysName].length >= 240) {
                systemTrendDictionary[trendItem.sysName].shift();
            }
            systemTrendDictionary[trendItem.sysName].push(trendItem);
        });
        self.systemTrendDictionary(systemTrendDictionary);
    }

    function switchTransmitAndReceive(obj) {
        switchValues(obj, 'txAudioCodec', 'rxAudioCodec');
        switchValues(obj, 'txVideoCodec', 'rxVideoCodec');
        switchValues(obj, 'txPresCodec', 'rxPresCodec');

        switchValues(obj, 'txAudioResolution', 'rxAudioResolution');
        switchValues(obj, 'txVideoResolution', 'rxVideoResolution');
        switchValues(obj, 'txPresResolution', 'rxPresResolution');

        switchValues(obj, 'txAudioFramerate', 'rxAudioFramerate');
        switchValues(obj, 'txVideoFramerate', 'rxVideoFramerate');
        switchValues(obj, 'txPresFramerate', 'rxPresFramerate');

        switchValues(obj, 'txAudioChannelrate', 'rxAudioChannelrate');
        switchValues(obj, 'txVideoChannelrate', 'rxVideoChannelrate');
        switchValues(obj, 'txPresChannelrate', 'rxPresChannelrate');

        switchValues(obj, 'txAudioPacketlossPerc', 'rxAudioPacketlossPerc');
        switchValues(obj, 'txVideoPacketlossPerc', 'rxVideoPacketlossPerc');
        switchValues(obj, 'txPresPacketlossPerc', 'rxPresPacketlossPerc');

        switchValues(obj, 'txAudioJitter', 'rxAudioJitter');
        switchValues(obj, 'txVideoJitter', 'rxVideoJitter');
        switchValues(obj, 'txPresJitter', 'rxPresJitter');

        if (obj.presentation === 'Receiving') {
            obj.presentation = 'Sending';

        } else if (obj.presentation === 'Sending') {
            obj.presentation = 'Receiving';
        }
    }

    function switchValues(obj, propName1, propName2) {
        var val3 = obj[propName1];
        obj[propName1] = obj[propName2];
        obj[propName2] = val3;
    }

    function toPacketLossPercent(packetLoss) {
        if (_.isEmpty(packetLoss)) {
            return '';
        }
        if (packetLoss < 0.0) {
            return '0.0';
        }
        if (packetLoss > 1.0) {
            return '100.0';
        }
        return (parseFloat(packetLoss) * 100.0).toFixed(1).toString();
    }

    export default {
        addIfNotEmpty: addIfNotEmpty,
        createSystemTrendDictionary: createSystemTrendDictionary,
        extractCallControlData: extractCallControlData,
        extractCallData: extractCallData,
        extractSystemStatuses: extractSystemStatuses,
        extractVMRData: extractVMRData,
        getSystemIdsAndNames: getSystemIdsAndNames,
        getSystemNames: getSystemNames,
        pushToMaxObservable: pushToMaxObservable,
        setSystemDetailParticipantData: setSystemDetailParticipantData,
        shiftSystemTrendDataValues: shiftSystemTrendDataValues
    };

